export function detectMobile(): boolean {
  return (window.innerWidth <= 600);
}

export function nullOrUndefined<T>(obj: T | null | undefined): boolean {
  return obj === null || obj === undefined;
}
